import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const SNAPTRADE_LINK_CHANNEL = 'vester:snaptrade-link';

export interface SnapTradeLinkPayload {
  type: 'snaptrade-link-complete';
  status: string;
  connectionId: string;
  error: string;
}

export function notifySnapTradeLinkComplete(payload: SnapTradeLinkPayload): void {
  try {
    const channel = new BroadcastChannel(SNAPTRADE_LINK_CHANNEL);
    channel.postMessage(payload);
    channel.close();
  } catch {
    // BroadcastChannel is best effort; localStorage provides a fallback signal.
  }

  try {
    localStorage.setItem(
      SNAPTRADE_LINK_CHANNEL,
      JSON.stringify({ ...payload, sentAt: Date.now() })
    );
  } catch {
    // Ignore storage failures in private browsing modes.
  }
}

const SnapTradeCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [canClose, setCanClose] = useState(true);

  const payload = useMemo<SnapTradeLinkPayload>(() => ({
    type: 'snaptrade-link-complete',
    status: searchParams.get('status') || '',
    connectionId: searchParams.get('connection_id') || searchParams.get('connectionId') || '',
    error: searchParams.get('error') || searchParams.get('error_message') || '',
  }), [searchParams]);

  useEffect(() => {
    notifySnapTradeLinkComplete(payload);

    const timer = window.setTimeout(() => {
      window.close();
      setCanClose(false);
    }, 400);

    return () => window.clearTimeout(timer);
  }, [payload]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-sm rounded-lg border border-gray-200 bg-white p-6 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-gray-900">
          {payload.error ? 'Connection failed' : 'Connection complete'}
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          {payload.error || (canClose ? 'Returning to Vester...' : 'You can close this window.')}
        </p>
      </div>
    </div>
  );
};

export default SnapTradeCallbackPage;
